var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoMLearn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.364 13.287v4.364L12 21.818l7.636-4.167v-4.364L12 17.455l-7.636-4.168zM12 2.182 0 8.727l12 6.546 9.818-5.357v7.539H24V8.727L12 2.182z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMLearn);
export default __webpack_public_path__ + "static/media/ico-m-learn.fc9fbda3.svg";
export { ForwardRef as ReactComponent };